<script setup lang="ts">
const bfMode = true;
console.log(bfMode);
</script>

<template>
  <div class="marquesina-container" v-if="bfMode">
    <div class="pill pill--green-bold pill--medium marquesina" />
  </div>
</template>

<style scoped lang="scss">
.marquesina-container {
  padding: 0;
}

.marquesina {
  width: 100%;
  height: calc(38px + 4px);
  overflow: hidden;
  background-image: url("@img/marquesina_bf.svg");
  background-repeat: repeat-x;
  background-size: 1820px 20px;
  background-position-y: center;
  animation: moveImage 20s linear infinite;
  padding: 1em;
}

@keyframes moveImage {
  0% {
    background-position-x: 0;
  }

  100% {
    background-position-x: -1820px;
  }
}
</style>
